import { createAsyncThunk } from '@reduxjs/toolkit';

import { CareerQuestion } from '@backrs_ui/grow-ui/src/models/models';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchCareerQuestions = createAsyncThunk(
  'survey/fetchSurveyQuestions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${ENVIRONMENT_URL}/career-question`);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as CareerQuestion[];
    } catch (error) {
      return rejectWithValue(`Failed to fetch career questions with error: ${error}`);
    }
  },
);
